import { SERVICE_PRINCIPAL_REQUIREMENT_REF_PREFIX } from './requirementRef.util'

// "servicePrincipal:<name>" is this domain's own sentinel prefix. The display name is the match
// key for a workload identity in another tenant.
export const REQUIREMENT_REF_PREFIX = SERVICE_PRINCIPAL_REQUIREMENT_REF_PREFIX

// Graph's selector for every service principal in the tenant. It is the same in every tenant, so
// it stays a literal value on a template and is never a requirement.
export const ALL_SERVICE_PRINCIPALS_IN_TENANT = 'ServicePrincipalsInMyTenant'

export const isRequirementRef = (value) => typeof value === 'string' && value.startsWith(REQUIREMENT_REF_PREFIX)

export const getRequirementId = (value) => (isRequirementRef(value) ? value.slice(REQUIREMENT_REF_PREFIX.length) : null)

export const toRequirementRef = (requirementId) => `${REQUIREMENT_REF_PREFIX}${requirementId}`

export const SERVICE_PRINCIPAL_REQUIREMENT_STATUS = {
  MATCHED: 'matched',
  UNRESOLVABLE: 'unresolvable',
}
